import { loginRequestSchema, UserWithMeta } from 'src/common-services/types/user-types'
import { z } from 'zod'

export const signUpRequestSchema = z.object({
  email: loginRequestSchema.shape.email,
  password: loginRequestSchema.shape.password,
})

export type SignUpRequest = z.infer<typeof signUpRequestSchema>
export type SignUpResponse = UserWithMeta

export const sendFeedbackRequestSchema = z.object({
  feedback: z.string(),
  email: z.string().email(),
  version: z.string(),
  platform: z.string(),
})

export type SendFeedbackRequest = z.infer<typeof sendFeedbackRequestSchema>
